import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import { envioAutorizacionApi } from "@/features/solicitudes/services/envio-autorizacion.api";

/**
 * Mutation para enviar la solicitud a autorización · navegación al
 * detalle queda a cargo del caller via `options.onSuccess`.
 */
export function useEnviarAAutorizacion(
  solicitudId: string,
  options?: { onSuccess?: () => void }
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => envioAutorizacionApi.enviar(solicitudId),
    onSuccess: (sol) => {
      qc.setQueryData(qk.solicitud(solicitudId), sol);
      toastExito({
        title: `Solicitud #${sol.numeroSolicitud} enviada`,
        message: "La solicitud entró al flujo de autorización.",
      });
      options?.onSuccess?.();
    },
    onError: toastErrorApi,
  });
}

/**
 * Mutation para reenviar la solicitud tras un rechazo · continúa desde
 * el nivel rechazado preservando autorizaciones previas (decisión 37).
 */
export function useReenviarSolicitud(
  solicitudId: string,
  options?: { onSuccess?: () => void }
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => envioAutorizacionApi.reenviar(solicitudId),
    onSuccess: (sol) => {
      qc.setQueryData(qk.solicitud(solicitudId), sol);
      qc.invalidateQueries({ queryKey: qk.misSolicitudes });
      toastExito({
        title: "Solicitud reenviada",
        message: `Continúa desde el nivel ${sol.flujo?.nivelActual ?? "?"} · las autorizaciones previas se conservan.`,
      });
      options?.onSuccess?.();
    },
    onError: toastErrorApi,
  });
}
